/* comments-invite.js — GitHub #10.
 *
 * Ghost's comments-ui renders a logged-out sales pitch we cannot edit: every string is
 * hardcoded inside comments-ui.min.js, served from a public CDN at a floating ~1.5 version
 * (1.5.168 when this was written). Not the theme, not Ghost admin, not our server.
 * It renders into a SAME-ORIGIN, JS-built iframe (component holds iframeHtml/iframeHead/
 * iframeRoot and reads this.node.contentDocument), so we are allowed to reach in.
 *
 * WHAT WE ANCHOR ON: only Ghost's own `data-testid` handles. These are authored by Ghost for
 * their e2e tests and survive minification as readable English. NEVER anchor on the minified
 * class names — those are machine-generated and churn between releases (decision CI2).
 *   [data-testid="cta-box"]          -> the pitch (a <section>)
 *   [data-testid="comment-elements"] -> the comment list (a SIBLING; must stay visible)
 *
 * FAILURE MODE, BY DESIGN (decision CI3): if Ghost renames `cta-box`, we hide nothing and we
 * reveal nothing -> the reader sees today's stock pitch. Degraded, never broken, and never
 * both at once. That ordering is the whole safety story; do not reorder it.
 */
(function () {
    'use strict';

    var CONTAINER = '.gh-comments[data-rp-invite]';
    var INVITE = '[data-rp-comments-invite]';
    var CTA_BOX = '[data-testid="cta-box"]';
    var STYLE_MARK = 'data-rp-comments-invite-style';
    var TIMEOUT_MS = 10000;
    var POLL_MS = 250;

    var container = document.querySelector(CONTAINER);
    var invite = container && container.querySelector(INVITE);

    // No container, or a logged-in member (the partial renders nothing for members): nothing to do.
    if (!container || !invite) {
        return;
    }

    function hidePitchIn(doc) {
        // Only proceed if the pitch is ACTUALLY there. This is the safeguard's gate: no pitch
        // found -> return false -> the invite stays hidden and Ghost's UI is left untouched.
        if (!doc.querySelector(CTA_BOX)) {
            return false;
        }

        if (!doc.querySelector('[' + STYLE_MARK + ']')) {
            var style = doc.createElement('style');
            style.setAttribute(STYLE_MARK, '');
            style.textContent = CTA_BOX + ' { display: none !important; }';
            (doc.head || doc.documentElement).appendChild(style);
        }

        return true;
    }

    function sameOriginDoc(frame) {
        // Cross-origin access throws; treat any failure as "not ours to touch".
        try {
            return frame.contentDocument || null;
        } catch (err) {
            return null;
        }
    }

    function tryFrames() {
        var frames = container.querySelectorAll('iframe');

        for (var i = 0; i < frames.length; i++) {
            var doc = sameOriginDoc(frames[i]);

            if (doc && hidePitchIn(doc)) {
                // ORDER MATTERS: only reveal once the pitch is confirmed hidden.
                invite.removeAttribute('hidden');
                return true;
            }
        }

        return false;
    }

    function stop() {
        observer.disconnect();
        clearInterval(poller);
        clearTimeout(timer);
    }

    // comments-ui builds its iframe asynchronously and then renders React inside it, so the
    // pitch does not exist at DOMContentLoaded. Watch the container until it appears, with a
    // hard stop so we never observe forever.
    var observer = new MutationObserver(function () {
        if (tryFrames()) {
            stop();
        }
    });

    // React renders INSIDE the iframe do not mutate the parent document, so a MutationObserver
    // on the container cannot see the pitch appear. Polling is what actually catches it; the
    // observer just makes the common case snappier. Both are bounded by TIMEOUT_MS.
    var poller = setInterval(function () {
        if (tryFrames()) {
            stop();
        }
    }, POLL_MS);

    var timer = setTimeout(function () {
        stop();
        // Deliberately leave the invite hidden. Stock Ghost wins by default.
    }, TIMEOUT_MS);

    observer.observe(container, {childList: true, subtree: true, attributes: true});

    if (tryFrames()) {
        stop();
    }
}());
